module.exports = __webpack_public_path__ + "img/pomegranate.688d2185.png";